import type {MutableRefObject} from "react";

import {debounceTillAnimationFrame} from "../../../utils/getDebounceAnimationFrame";


export const getDebounceUpdateScrollShiftHandle = (
    contextRootRef: MutableRefObject<HTMLDivElement | null>,
    scrollRootRef: MutableRefObject<HTMLDivElement | null>
) => {
    return () => {
        if (contextRootRef.current !== null) {
            debounceTillAnimationFrame(() => {
                if (contextRootRef.current !== null) {
                    contextRootRef.current!.style.top = `-${scrollRootRef.current!.scrollTop}px`;
                }
            });
        }
    };
}
